<h2 mat-dialog-title>{{ editMode ? 'Edit' : 'Add' }} board</h2>
<form [formGroup]="form" (ngSubmit)="ok()">
  <mat-dialog-content>
    <div class="form">
      <div class="grid">
        <app-radio-button-dropdown
          [labelCss]="'nowrap pre-label'"
          [valueCss]="'pre-title text-color fs s14 dark'"
          formControlName="boardType"
          [containerCss]="'display-flex flex-column grid-gap-4'"
          [items]="boardTypeList"
          [allowClear]="false"
          [labelInside]="false"
          [label]="'Type'"
          [attrAppendTo]="'body'"
          [attrDisable]="!!data?.id"
          [errorSection]="false"
        ></app-radio-button-dropdown>
        <app-input
          [labelCss]="'nowrap pre-label'"
          [containerCss]="'display-flex flex-column grid-gap-4'"
          [attrPlaceholder]="'Board name...'"
          formControlName="name"
          [attrLabel]="'Name'"
          [errorSection]="false"
        ></app-input>
      </div>

      <div class="text-centered">
        <button class="fs s14 button-text" (click)="toggleAdvancedSettings()" type="button">Advanced settings</button>
      </div>

      <div class="advanced-settings-wrapper" [ngClass]="{ 'is-open': isSettingsOpened }">
        <div class="advanced-settings">
          <div class="grid">
            <app-radio-button-dropdown
              [labelCss]="'nowrap pre-label'"
              [valueCss]="'pre-title text-color fs s14 dark'"
              formControlName="selectedPortfolioIds"
              [containerCss]="'display-flex flex-column grid-gap-4'"
              [items]="userPortfolios"
              [allowClear]="false"
              [labelInside]="false"
              [label]="'Portfolio association'"
              [multiSelect]="true"
              [attrAppendTo]="'body'"
              [errorSection]="false"
            ></app-radio-button-dropdown>

            <div></div>

            <app-radio-button-dropdown
              [labelCss]="'nowrap pre-label'"
              [valueCss]="'pre-title text-color fs s14 dark'"
              formControlName="datasource"
              [containerCss]="'display-flex flex-column grid-gap-4'"
              [items]="boardSourceTypeList"
              [allowClear]="false"
              [labelInside]="false"
              [label]="'Start with units in'"
              [attrAppendTo]="'body'"
              [attrDisable]="!!data?.id"
              [errorSection]="false"
            ></app-radio-button-dropdown>

            <app-radio-button-dropdown
              [labelCss]="'nowrap pre-label'"
              [valueCss]="'pre-title text-color fs s14 dark'"
              formControlName="outputAction"
              [containerCss]="'display-flex flex-column grid-gap-4'"
              [items]="boardOutputTypeList"
              [allowClear]="true"
              [labelInside]="false"
              [label]="'End by sending turn to'"
              [attrAppendTo]="'body'"
              [errorSection]="false"
            ></app-radio-button-dropdown>

            <app-radio-button-dropdown
              [labelCss]="'nowrap pre-label'"
              [valueCss]="'pre-title text-color fs s14 dark'"
              formControlName="progressType"
              [containerCss]="'display-flex flex-column grid-gap-4'"
              [items]="progressTypeList"
              [allowClear]="false"
              [labelInside]="false"
              [label]="'Update progress bar in'"
              [attrAppendTo]="'body'"
              [errorSection]="false"
            ></app-radio-button-dropdown>

            <app-radio-button-dropdown
              [labelCss]="'nowrap pre-label'"
              [valueCss]="'pre-title text-color fs s14 dark'"
              formControlName="outputBehaviour"
              [containerCss]="'display-flex flex-column grid-gap-4'"
              [items]="boardOutputBehaviorList"
              [allowClear]="true"
              [labelInside]="false"
              [label]="'Remove rows'"
              [attrAppendTo]="'body'"
              [errorSection]="false"
            ></app-radio-button-dropdown>
          </div>

          <app-custom-color-picker
            [labelCss]="'nowrap pre-label'"
            [valueCss]="'pre-title text-color fs s14 dark'"
            formControlName="boardCellColor"
            [containerCss]="'display-flex flex-column grid-gap-4'"
            [label]="'Cell color'"
          ></app-custom-color-picker>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="actions">
    <div class="display-flex grid-gap-8 justify-content-end w-100">
      <button mat-stroked-button color="warn" class="modal-button" (click)="close()" type="button">Cancel</button>
      <button mat-raised-button color="primary" class="modal-button" type="submit">
        <div class="display-flex align-items-center grid-gap-4">
          {{ editMode ? 'Save' : 'Add' }}
          <mat-spinner *ngIf="inProgress$ | async" color="accent" diameter="20"></mat-spinner>
        </div>
      </button>
    </div>
  </mat-dialog-actions>
</form>
